import { useGlobal } from '@rcg/ui-react';
import Dictionary from '../utils/dictionary';

const useRenderContent = () => {
  const { renderContent } = useGlobal();
  const useLocalDictionary = process.env.REACT_APP_USE_LOCAL_DICTIONARY === 'true';

  return (key, defaultValue) => {
    // If the switch is disabled, use only AEM (normal behavior)
    if (!useLocalDictionary) {
      return renderContent(key, defaultValue);
    }

    // If the switch is enabled: prioritize local dictionary.json
    // Search for the key in the local Dictionary
    const localEntry = Object.values(Dictionary).find((entry) => entry.key === key);

    // If it exists locally, use its defaultValue
    if (localEntry && localEntry.defaultValue) {
      return localEntry.defaultValue;
    }

    // If it doesn't exist locally, search in AEM as fallback
    return renderContent(key, defaultValue);
  };
};

export default useRenderContent;
